import React from "react";

const Footer = () =>
<footer>
    The information contained on this website is provided for informational purposes only, and should not be considered legal advice on any matter
</footer>
export default Footer;
